<template>
    <div class="wrapper">
        <!-- <page-header></page-header> -->
        <page-title :title="title"></page-title>
        <div class="detail-content-box">
          <div class="detail-content">
            <div class="content-top">
              <el-tag v-if="studentCpp" class="stu-name">{{studentCpp['name_zh']}}/{{studentCpp['name_en']}}</el-tag>
              <div class="float-box" style="overflow:hidden">
                <div class="float-left" style="padding-right:60px;padding-bottom:30px;float:left">
                  <p class="content-title">ISSUE市场经理：</p>
                  <ul class="content-top-info-wrap">
                    <li><i class="iconfont icon-lianxiren"></i><span class="content-top-info">{{adviser_n}}</span></li>
                    <li><i class="iconfont icon-youxiang"></i><span class="content-top-info">{{adviser_e}}</span></li>
                  </ul>
                </div>
                <template v-for="(item,idx) in rcinfo">
                  <div class="float-left" style="padding-right:60px;padding-bottom:30px;float:left" :key="idx">
                    <p class="content-title">ISSUE跟进顾问：</p>
                    <ul class="content-top-info-wrap">
                      <li><span class="content-top-info">Country：</span><span class="content-top-info">{{item.country}}</span></li>
                      <li><i class="iconfont icon-lianxiren"></i><span class="content-top-info">{{item.name}}</span></li>
                      <li><i class="iconfont icon-youxiang"></i><span class="content-top-info">{{item.email}}</span></li>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
            <div class="content-middle">
              <p class="content-title">申请院校</p>
              <el-tabs type="border-card" v-if="showTable">
                <el-tab-pane v-for="(item, index) in schoolnames" :key="index" >
                  <span slot="label"><i class="iconfont icon-university2"></i> {{item}}</span>
                  <el-card class="box-card" v-for="(item, index) in courses[index]" :key="index">
                    <div slot="header" class="clearfix">
                      <p class="courseNum">课程{{(Number(index)+1)}}</p>
                      <!-- <span>University of New South Wales Foundation > standard plus foundation + Bachelor of Science （Computer Science）</span> -->
                    </div>
                    <div class="text item">
                      <span>{{course_details[0]}}</span><span>{{item['state']}}</span>
                    </div>
                    <div class="text item">
                      <span>{{course_details[1]}}</span><span>{{item['country']}}</span>
                    </div>
                    <!-- <div  class="text item">
                      <span>{{course_details[2]}}</span><span>{{item['majortype']}}</span>
                    </div>
                    <div  class="text item">
                      <span>{{course_details[3]}}</span><span>{{item['coursetype']}}</span>
                    </div> -->
                    <div  class="text item">
                      <span>{{course_details[4]}}</span><span>{{item['coursename']}}</span>
                    </div>
                    <div  class="text item">
                      <span>{{course_details[5]}}</span><span>{{item['begintime']}}</span>
                    </div>
                    <div  class="text item">
                       <span>{{course_details[6]}}</span><span>{{item['state']}}</span>
                    </div>
                    <div  class="text item">
                      <span>{{course_details[7]}}</span><span>{{datetd[index]}}</span>
                    </div>
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import PageTitle from '../components/PageTitle'
import PageHeader from '../components/PageHeader'
export default {
  name: 'StudentDetail',
  data () {
    return {
      title: '學生詳情列表',
      course_details: ['申請狀態：', '申請國家：', '學校類型：', '課程等級：', '專業名稱：', '開課日期：', '申請狀態：', '初錄時間：'],
      courses: [],
      schoolnames: [],
      state: [],
      courseplans: [],
      studentCpp: {},
      rcinfo: [],
      adviser_n: '',
      adviser_e: '',
      datetd: [],
      id: ''
    }
  },
  created () {
    this.id = this.getUrlStr('id')
    this.$nextTick(() => {
      this.getData()
    })
  },
  destroyed () {
    localStorage.setItem('id', '')
  },
  methods: {
    getData () {
      let that = this
      console.log('axios')
      this.$axios({
        method: 'get',
        url: '/stu_appl/getStudentDetailByCppStuId?studentid=' + that.id
        // url: 'api/jsondata.json'
      }).then(res => {
        res = res.data
        console.log(!res.courseplans && !res.studentCpp, res.courseplans, res.studentCpp)
        if (!res.courseplans && !res.studentCpp) {
          // alert(' Login has expired, Please login again 登錄過期，請重新登錄！')
          sessionStorage.removeItem('id')
          that.$router.push({ name: 'login' })
        } else {
          console.log('detail')
          that.studentCpp = res.studentCpp
          if (res.rcInfo) {
            that.rcinfo = res.rcInfo
          }
          console.log(res.studentCpp['nameandemail'])
          if (res.studentCpp['nameandemail'] !== undefined && typeof res.studentCpp['nameandemail'] === 'string') {
            let adviser = that.studentCpp['nameandemail'].split(' -- ')
            that.adviser_n = adviser[0]
            that.adviser_e = adviser[1]
          }
          for (let i = 0; i < res.courseplans.length; i++) {
            that.schoolnames.push(res.courseplans[i].schoolname)
            that.state.push(res.courseplans[i].state)
            let course = {}
            if (res.courseplans[i].course_details && res.courseplans[i].course_details.length) {
              res.courseplans[i].course_details.forEach((element, index) => {
                course[index] = element
              })
              that.courses.push(course)
            }
          }
          that.getTime(res.courseplans)
        }
      }).catch(err => {
        alert(err)
        sessionStorage.removeItem('id')
        that.$router.push({ name: 'login' })
      })
    },
    getUrlStr (name) {
      /**
       * 获取地址栏参数
       */
      let reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(window.location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      }
      return undefined
    },
    getTime (datas) { // 待解决
      for (let i = 0; i < datas.length; i++) {
        if (datas[i].course_details[0].createtime && typeof datas[i].course_details[0].createtime === 'string') {
          let dateval = datas[i].course_details[0].createtime.split('-')
          var months = Number(dateval[1])
          if (months <= 2) {
            this.datetd.push('Q1')
          } else if (months <= 6) {
            this.datetd.push('Q2')
          } else if (months <= 10) {
            this.datetd.push('Q3')
          } else if (months <= 12) {
            this.datetd.push('Q4')
          }
        }
      }
    }
  },
  computed: {
    showTable () {
      return this.courses.length
    }
  },
  components: {
    PageTitle,
    PageHeader
  }
}
</script>

<style lang="stylus" scoped>
  .content-middle  >>> .el-tabs__nav-prev
    width 20px
    color #555555
    .el-icon-arrow-left
      font-size 20px
      font-weight 600
  .content-middle >>>.el-tabs__nav-next
    width 20px
    color #555555
    .el-icon-arrow-right
      font-size 20px
      font-weight 600
  .text
    font-size 14px
  .item
    padding 18px 0
  .box-card
    width 600px
  .box-card
    margin 0 auto
  .content-middle,.content-top
    width 1000px
    margin 10px auto
  .content-top
    overflow hidden
  .stu-name
    width 100%
    margin-bottom 5px
    font-size 16px
    font-weight 600
    border 0
  .content-title
    font-size 20px
  .content-top-info-wrap>li
    margin-left 20px
    .content-top-info
      margin 0 15px
      font-size 16px
  .text.item
    span:nth-child(1)
      margin-right 30px
      margin-left 20px
  .courseNum
    font-size 16px
</style>



// WEBPACK FOOTER //
// src/views/StudentDetail.vue